import { registerSW as registerVitePWA } from 'virtual:pwa-register';

export function registerSW() {
  if (import.meta.env.DEV) return;
  registerVitePWA({
    immediate: true,
    onNeedRefresh() {
      // autoUpdate handles this; surface a toast if desired later
    },
    onOfflineReady() {
      // no-op for now
    },
  });
}
